import React, { Suspense } from "react";
import { Provider as IntlProvider } from "context/Intl";
import { Provider as FlashMessagesProvider } from "context/FlashMessages";
import { BrowserRouter } from "react-router-dom";
import FlashMessages from "components/App/FlashMessages";
import ErrorBoundary from "components/App/ErrorBoundary";
import Loader from "components/App/Loader";
import ModuleRouter from "./ModuleRouter";
import Config from "app/config";

const App: React.FC = () => {
    return (
        <IntlProvider>
            <ErrorBoundary>
                <FlashMessagesProvider FlashComponent={FlashMessages}>
                    <BrowserRouter basename={Config.getBaseUrl()}>
                        <Suspense fallback={<Loader />}>
                            <ModuleRouter />
                        </Suspense>
                    </BrowserRouter>
                </FlashMessagesProvider>
            </ErrorBoundary>
        </IntlProvider>
    );
};

export default App;
